import { render } from "./central-header.vue?vue&type=template&id=664394e1"
import script from "./central-header.vue?vue&type=script&lang=js"
export * from "./central-header.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__